import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import AddVehicleForm from './AddVehicleForm';

const AddVehicleDialog = ({ open, onOpenChange, onAddVehicle }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (vehicleData) => {
    setIsSubmitting(true);
    try {
      await onAddVehicle(vehicleData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
   <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Add New Vehicle</DialogTitle>
        </DialogHeader>
        <AddVehicleForm onSubmit={handleSubmit} isSubmitting={isSubmitting} onCancel={handleCancel} />
      </DialogContent>
    </Dialog>
  );
};

export default AddVehicleDialog;